import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styles from './LoginSignup.module.css';
import axios from 'axios';
import { URL } from '../AxiosUrlGlobal';
import Logo from '../../img/logo.png';

/* ─── Inline icons (matching LoginSignup) ─────────────────────────── */
const ArrowRight = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
    </svg>
);

const PhoneIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.13.96.37 1.9.72 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0122 16.92z" />
    </svg>
);

const KeyIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 11-7.778 7.778 5.5 5.5 0 017.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" />
    </svg>
);

const CopyIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
        <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
    </svg>
);

const StarIcon = () => (
    <svg viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>
);

/**
 * Normalize Bangla digits to Latin digits so the API always receives
 * a clean ASCII numeric string regardless of keyboard / IME / locale.
 */
const toLatinDigits = (s = '') =>
    String(s).replace(/[\u09e6-\u09ef]/g, (d) => String(d.charCodeAt(0) - 0x09e6));

function ForgotPassword() {
    const navigate = useNavigate();
    const [stage, setStage] = useState('mobile'); // 'mobile' | 'otp' | 'done'
    const [forgotNumber, setForgotNumber] = useState('');
    const [verifyCode, setVerifyCode] = useState('');
    const [userId, setUserId] = useState(null);
    const [getPass, setGetPass] = useState(null);
    const [loading, setLoading] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const handleForgot = async () => {
        if (!forgotNumber) {
            toast.error('মোবাইল নম্বর দিন');
            return;
        }
        if (forgotNumber.length !== 11) {
            toast.error('১১ সংখ্যার মোবাইল নম্বর লিখুন');
            return;
        }
        try {
            setLoading(true);
            const res = await axios.post(`${URL}forgot/mobile`, { number: forgotNumber });
            if (res.data.otpStatus) {
                setUserId(res.data.userId);
                setStage('otp');
                toast.success('আপনার মোবাইলে OTP পাঠানো হয়েছে');
            } else {
                toast.error(res.data.message || 'OTP পাঠাতে সমস্যা হয়েছে');
            }
        } catch (err) {
            toast.error('OTP পাঠাতে সমস্যা হয়েছে। আবার চেষ্টা করুন।');
        } finally {
            setLoading(false);
        }
    };

    const handleOtpVerify = async () => {
        if (!verifyCode) {
            toast.error('ভেরিফিকেশন কোড দিন');
            return;
        }
        try {
            setLoading(true);
            const res = await axios.post(`${URL}otp/validate`, {
                userId,
                otp: verifyCode,
            });
            if (res.data.message === 'OTP is valid') {
                setGetPass(res.data.pass);
                setStage('done');
                toast.success('ভেরিফাই সফল!');
            } else {
                toast.error(res.data.message || 'OTP ভুল');
            }
        } catch (err) {
            const errorMessage = err.response?.data || 'OTP ভেরিফাইয়ে সমস্যা হয়েছে';
            toast.error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    const handleCopyPassword = () => {
        if (!getPass) return;
        navigator.clipboard.writeText(getPass).then(() => {
            toast.success('পাসওয়ার্ড কপি হয়েছে!');
        });
    };

    const handleKeyDown = (e, action) => {
        if (e.key === 'Enter') action();
    };

    return (
        <div className={styles['login-container']} lang="bn">
            <ToastContainer />

            {/* ─── Mobile-only top header ─────────────────────────── */}
            <div className={styles['header-login']}>
                <Link to="/" className={styles['nav-brand']}>
                    <span className={styles['nav-brand-logo']}>
                        <img src={`${process.env.PUBLIC_URL}/logo512.png`} alt="ইকমটেক" />
                    </span>
                    ইকমটেক
                </Link>
                <div className={styles['login-main']}>
                    <ul>
                        <li onClick={() => navigate('/teamlogin')}>টিম লগইন</li>
                        <li onClick={() => navigate('/?tab=signup')}>সাইন আপ</li>
                        <li onClick={() => navigate('/?tab=login')}>লগইন</li>
                    </ul>
                </div>
                <div
                    className={styles['mobile-menu-icon']}
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                >
                    <span></span><span></span><span></span>
                </div>
                {mobileMenuOpen && (
                    <div className={styles['mobile-menu']}>
                        <div
                            className={styles['mobile-menu-close']}
                            onClick={() => setMobileMenuOpen(false)}
                        >×</div>
                        <ul>
                            <li onClick={() => { navigate('/teamlogin'); setMobileMenuOpen(false); }}>টিম লগইন</li>
                            <li onClick={() => { navigate('/?tab=signup'); setMobileMenuOpen(false); }}>সাইন আপ</li>
                            <li onClick={() => { navigate('/?tab=login'); setMobileMenuOpen(false); }}>লগইন</li>
                        </ul>
                    </div>
                )}
            </div>

            {/* ─── Two-column layout (form 60% LEFT, branding 40% RIGHT) ──── */}
            <div className={styles['login-signup-main']}>

                {/* RIGHT — branding pane (reused from LoginSignup) */}
                <aside className={styles['marketing-pane']}>
                    <div className={styles['marketing-top']}>
                        <Link to="/" className={styles['marketing-brand']}>
                            <span className={styles['marketing-brand-dot']}>
                                <img src={`${process.env.PUBLIC_URL}/logo512.png`} alt="ইকমটেক" />
                            </span>
                            <span className={styles['marketing-brand-name']}>ইকমটেক</span>
                        </Link>
                    </div>

                    <div className={styles['marketing-body']}>
                        <div>
                            <p className={styles['marketing-eyebrow']}>
                                বাংলাদেশের কমার্স প্ল্যাটফর্ম
                            </p>
                            <h2 className={styles['marketing-headline']}>
                                চিন্তা নেই —
                                <span className={styles.grad}>পাসওয়ার্ড রিকভার করুন সহজেই</span>
                            </h2>
                            <p className={styles['marketing-sub']}>
                                মোবাইল নম্বর আর OTP দিয়ে কয়েক সেকেন্ডে আপনার পাসওয়ার্ড
                                ফিরে পান। তারপর ড্যাশবোর্ডে ফিরে যান এবং বিজনেস চালিয়ে যান।
                            </p>
                        </div>

                        <ul className={styles['feature-list']}>
                            <li className={styles['feature-item']}>
                                <span className={styles['feature-icon']}><PhoneIcon /></span>
                                <div className={styles['feature-text']}>
                                    <p className={styles['feature-title']}>SMS-এ OTP</p>
                                    <p className={styles['feature-desc']}>আপনার মোবাইলে ইনস্ট্যান্ট ভেরিফিকেশন কোড</p>
                                </div>
                            </li>
                            <li className={styles['feature-item']}>
                                <span className={styles['feature-icon']}><KeyIcon /></span>
                                <div className={styles['feature-text']}>
                                    <p className={styles['feature-title']}>ইনস্ট্যান্ট রিকভারি</p>
                                    <p className={styles['feature-desc']}>OTP ভেরিফাই হলেই সাথে সাথে পাসওয়ার্ড পান</p>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div className={styles['marketing-footer']}>
                        <div className={styles['avatar-stack']}>
                            <span>র</span>
                            <span>আ</span>
                            <span>স</span>
                            <span>+</span>
                        </div>
                        <div className={styles['social-text']}>
                            <div className={styles['stars-row']}>
                                <StarIcon /><StarIcon /><StarIcon /><StarIcon /><StarIcon />
                                <span className={styles['stars-rating']}>৪.৯/৫</span>
                            </div>
                            <p className={styles['stars-caption']}>
                                ১০,০০০+ বাংলাদেশী সেলারের আস্থা
                            </p>
                        </div>
                    </div>
                </aside>

                {/* LEFT — form pane */}
                <main className={styles['form-pane']}>
                    <div className={styles['form-pane-inner']}>

                        <div className={styles['form-heading-block']}>
                            <h1 className={styles['form-heading']}>
                                {stage === 'mobile' && 'পাসওয়ার্ড ভুলে গেছেন?'}
                                {stage === 'otp' && 'কোড ভেরিফাই করুন'}
                                {stage === 'done' && 'আপনার নতুন পাসওয়ার্ড'}
                            </h1>
                            <p className={styles['form-subheading']}>
                                {stage === 'mobile' && 'মোবাইল নম্বর দিন। আমরা OTP পাঠিয়ে দেব।'}
                                {stage === 'otp' && 'আপনার মোবাইলে পাঠানো ৬ ডিজিটের কোড লিখুন।'}
                                {stage === 'done' && 'নিচের পাসওয়ার্ডটি কপি করে লগইন করুন।'}
                            </p>
                        </div>

                        {stage === 'mobile' && (
                            <div className={styles['login-inputs']}>
                                <div className={styles['field']}>
                                    <div className={styles['field-label-row']}>
                                        <label className={styles['field-label']}>মোবাইল নম্বর</label>
                                    </div>
                                    <div className={styles['field-input-wrap']}>
                                        <input
                                            type="tel"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            lang="en"
                                            placeholder="01XXXXXXXXX"
                                            value={forgotNumber}
                                            onChange={(e) => setForgotNumber(toLatinDigits(e.target.value))}
                                            onKeyDown={(e) => handleKeyDown(e, handleForgot)}
                                            disabled={loading}
                                        />
                                    </div>
                                </div>

                                <button
                                    type="button"
                                    className={styles['login-btn']}
                                    onClick={handleForgot}
                                    disabled={loading}
                                >
                                    {loading ? <span className={styles.spinner} /> : null}
                                    {loading ? 'পাঠানো হচ্ছে…' : 'OTP পাঠান'}
                                    {!loading && <ArrowRight />}
                                </button>

                                <div className={styles['mode-switch']}>
                                    <p>
                                        মনে পড়েছে?
                                        <button onClick={() => navigate('/?tab=login')}>
                                            লগইনে ফিরে যান
                                        </button>
                                    </p>
                                </div>
                            </div>
                        )}

                        {stage === 'otp' && (
                            <div className={styles['otp-verify-section']}>
                                <div className={styles['otp-icon']}>
                                    <PhoneIcon />
                                </div>
                                <div className={styles['otp-message']}>
                                    <p>আপনার মোবাইলে একটি ভেরিফিকেশন কোড পাঠানো হয়েছে</p>
                                    <p>কোডটি নিচে লিখুন</p>
                                </div>
                                <input
                                    type="tel"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    lang="en"
                                    placeholder="৬ ডিজিটের কোড লিখুন"
                                    value={verifyCode}
                                    onChange={(e) => setVerifyCode(toLatinDigits(e.target.value))}
                                    className={styles['otp-input']}
                                    onKeyDown={(e) => handleKeyDown(e, handleOtpVerify)}
                                    disabled={loading}
                                />
                                <button
                                    type="button"
                                    className={styles['login-btn']}
                                    onClick={handleOtpVerify}
                                    disabled={loading}
                                >
                                    {loading ? <span className={styles.spinner} /> : null}
                                    {loading ? 'ভেরিফাই হচ্ছে…' : 'কোড ভেরিফাই করুন'}
                                    {!loading && <ArrowRight />}
                                </button>
                                <p
                                    className={styles['resend-text']}
                                    onClick={() => setStage('mobile')}
                                >
                                    কোড পাননি?
                                    <span>আবার পাঠান</span>
                                </p>
                            </div>
                        )}

                        {stage === 'done' && (
                            <div className={styles['login-inputs']}>
                                <div className={styles['pass-reveal']}>
                                    <div className={styles['pass-reveal-label']}>
                                        <KeyIcon />
                                        আপনার নতুন পাসওয়ার্ড
                                    </div>
                                    <div className={styles['pass-reveal-code']}>
                                        {getPass}
                                    </div>
                                    <button
                                        type="button"
                                        className={styles['pass-reveal-copy']}
                                        onClick={handleCopyPassword}
                                    >
                                        <CopyIcon />
                                        কপি করুন
                                    </button>
                                </div>

                                <p className={styles['pass-reveal-warn']}>
                                    এই পাসওয়ার্ডটি সংরক্ষণ করুন। লগইনের পর ড্যাশবোর্ডের
                                    Settings থেকে পরিবর্তন করতে পারবেন।
                                </p>

                                <button
                                    type="button"
                                    className={styles['login-btn']}
                                    onClick={() => navigate('/?tab=login')}
                                >
                                    লগইন পেজে যান <ArrowRight />
                                </button>
                            </div>
                        )}
                    </div>
                </main>
            </div>
        </div>
    );
}

export default ForgotPassword;
